import React from 'react';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';
import { Link } from '@carbon/react';
import { prefersReducedMotion } from 'src/utils/motion';

interface StatCardProps {
  icon: React.ReactElement;
  title: string;
  value: number;
  /** Money values pass useMoney's format/formatCompact; a plain count leaves this unset. */
  format?: (value: number) => string;
  /** Money values pass useMoney's decimals (CountUp rounds to 0 before formattingFn otherwise). */
  decimals?: number;
  onClick?: () => void;
}

const StatCard = React.memo((props: StatCardProps) => {
  const { t } = useTranslation('dashboard');
  // The tile counts up over 2s while everything beside it — the sales-goal meter especially —
  // prints its figure at once, so for those 2s the page reads as though the dashboard disagrees
  // with itself. Anyone who has asked their OS for less motion should see the number, not the
  // count; countup.js treats `duration: 0` as "print the end value" rather than falling back to
  // its default, so this is one code path, not two renderings to keep formatted alike.
  const duration = prefersReducedMotion() ? 0 : undefined;
  return (
    <div className="dashboard__stat_widget dashboard__stat_widget--with-icon">
      <h4>{props.title}</h4>
      <h3>
        <CountUp end={props.value} decimals={props.decimals ?? 0} formattingFn={props.format} duration={duration} />
      </h3>
      <Link onClick={props.onClick}>{t('viewDetails')}</Link>
      <div className="icon">{props.icon}</div>
    </div>
  );
});

export default StatCard;
